import React, { useState } from 'react';

// 页面模板：带 Tab 的列表页
// 适合“全部 / 待审核 / 已通过 / 已退回”这类页面。

// ================= 页面数据 =================
const MOCK_DATA = [
  {
    id: 1,
    name: '申请记录一',
    student: '陈红',
    score: '+2',
    status: '待审核',
  },
  {
    id: 2,
    name: '申请记录二',
    student: '林峰',
    score: '+1',
    status: '已通过',
  },
  {
    id: 3,
    name: '申请记录三',
    student: '王明',
    score: '+3',
    status: '已退回',
  },
];

export default function TemplateTabbedPage() {
  // ================= 页面状态 =================
  const [activeTab, setActiveTab] = useState('全部');
  const [keyword, setKeyword] = useState('');

  // ================= Tab 配置 =================
  const tabs = [
    '全部',
    '待审核',
    '已通过',
    '已退回',
  ];

  // ================= 查询逻辑 =================
  const filteredData = MOCK_DATA.filter(item => {
    if (activeTab !== '全部' && item.status !== activeTab) return false;
    if (keyword && !item.name.includes(keyword) && !item.student.includes(keyword)) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      {/* 顶部 Tab：新增状态时，修改 tabs 数组即可 */}
      <div className="bg-white px-4 pt-4 border-b border-slate-200">
        <div className="flex gap-6">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-3 text-sm font-medium border-b-2 transition-colors ${activeTab === tab ? 'border-blue-500 text-blue-600' : 'border-transparent text-slate-600 hover:text-blue-500'}`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* 条件筛选卡片 */}
      <div className="bg-white rounded shadow-sm border border-slate-200 p-4">
        <div className="flex items-center gap-2 max-w-md">
          <span className="text-sm text-slate-700 w-24 text-right shrink-0 whitespace-nowrap">
            关键词：
          </span>
          <input
            value={keyword}
            onChange={event => setKeyword(event.target.value)}
            type="text"
            placeholder="请输入事项或学生姓名"
            className="border border-slate-300 rounded px-3 py-1.5 text-sm flex-1 min-w-0 outline-none"
          />
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end mt-4 pt-4 border-t border-slate-100 gap-2">
          <button
            onClick={() => setKeyword('')}
            className="px-6 py-1.5 border border-slate-300 rounded text-sm hover:bg-slate-50 transition-colors"
          >
            重置
          </button>
          <button className="px-6 py-1.5 bg-blue-500 text-white rounded text-sm hover:bg-blue-600 shadow-sm transition-colors">
            查询
          </button>
        </div>
      </div>

      {/* 结果卡片 */}
      <div className="bg-white rounded shadow-sm border border-slate-200 p-4">
        {/* 结果表格 */}
        <div className="overflow-x-auto border border-slate-200 rounded shadow-inner">
          <table className="w-full text-sm text-left">
            <thead className="bg-slate-50 text-slate-700 font-medium">
              <tr>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  序号
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  申请事项
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  学生姓名
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  申请分数
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  状态
                </th>
                <th className="p-3 border-b border-slate-200 whitespace-nowrap">
                  操作
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {filteredData.map((row, index) => (
                <tr key={row.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-3 whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="p-3 whitespace-nowrap font-medium text-slate-800">
                    {row.name}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {row.student}
                  </td>
                  <td className="p-3 whitespace-nowrap text-green-600 font-medium">
                    {row.score}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    {row.status}
                  </td>
                  <td className="p-3 whitespace-nowrap">
                    <button className="text-blue-500 hover:text-blue-700 font-medium">
                      查看
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
